<template>
    <div class="form-field-text">
        <label :for="id" :class="labelClasses">{{ label }}</label>
        <div class="mt-2.5">
            <input
                :type="type"
                :name="id"
                :id="id"
                :placeholder="placeholder"
                :autocomplete="autocomplete"
                :value="value"
                @input="
                    (event) => {
                        $emit('update', {field, value: event.target.value, event});
                    }
                "
                :class="inputClasses"
                @focus="
                    (event) => {
                        $emit('focused', {field, value: event.target.value, event});
                    }
                "
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormFieldText',
    props: {
        id: {
            required: false,
            type: String,
            default: null,
        },
        label: {
            required: false,
            type: String,
            default: null,
        },
        field: {
            required: false,
            type: String,
            default: null,
        },
        value: {
            required: false,
            type: String,
            default: null,
        },
        placeholder: {
            required: false,
            type: String,
            default: null,
        },
        type: {
            required: false,
            type: String,
            default: 'text',
        },
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
        autocomplete: {
            required: false,
            type: String,
            default: null,
        },
    },
    computed: {
        labelClasses() {
            const cls = {};
            cls['text-md block font-medium leading-6 text-gray-900'] = true;
            return cls;
        },
        inputClasses() {
            const cls = {};
            cls['block w-full rounded-md border-0 px-4 py-2.5 shadow-xs'] = true;
            cls['sm:text-sm sm:leading-6'] = true;
            cls['text-gray-900 placeholder:text-gray-400'] = true;
            cls['ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-purple-600'] = true;
            return cls;
        },
    },
};
</script>
